import React, {PropsWithChildren, useMemo} from 'react';
import {AppLayout, MenuItem, MenuItemProps, Modal} from '@mc/ui-v4';
import {ModalQR} from './modals/ModalQR';
import logo from '../logo.png';
import {useMapioContext} from '../mapioContext';
import {Switch} from 'react-router-dom';
import {DAVKA_DTM_PAGE_KEY, MAPA_PAGE_KEY} from '../const/PageKeys';
import {getDavkyDtmUrl, getMapaUrl} from '../utils/urlRedirectUtils';
import {DownloadLayerDataModal} from './modals/DownloadLayerDataModal';

type Props = {isServerPublic?: boolean; isDtm?: boolean};
export const MapioAppLayout: React.FC<PropsWithChildren<Props>> = ({isServerPublic, isDtm, children}) => {
    const mapioContext = useMapioContext();
    const {isIframe} = mapioContext.value;

    const menuItems = useMemo<MenuItemProps[]>(() => {
        const items = [];
        if (isDtm) {
            items.push([
                {label: 'Mapa', key: MAPA_PAGE_KEY, link: {to: getMapaUrl()}},
                {label: 'Dávky DTM', key: DAVKA_DTM_PAGE_KEY, link: {to: getDavkyDtmUrl()}},
            ]);
        }
        return items;
    }, [isDtm]);

    return isIframe ? (
        <Switch>{children}</Switch>
    ) : (
        <AppLayout
            navbar={{
                userMenu: {
                    items: [
                        <MenuItem
                            key={'pairing'}
                            onClick={() => Modal.show(({onClose}) => <ModalQR onClose={onClose} />)}
                            text={'Párování mobilní aplikace'}
                        />,
                        <MenuItem
                            key={'stahnout-data-vrstvy-dle-ipr'}
                            onClick={() => Modal.show(({onClose}) => <DownloadLayerDataModal onClose={onClose} />)}
                            text={'Stáhnout data vrstvy dle IPR'}
                        />,
                    ],
                    hideLoginButton: isServerPublic ?? false,
                    hideNapovedaMenuItem: isServerPublic ?? false,
                },
                icon: <img src={logo} alt={'Mapiio'} />,
                brand: 'Mapiio',
                ...(isServerPublic
                    ? {}
                    : {
                          appMenu: {
                              menuItems: menuItems,
                          },
                      }),
            }}
        >
            <Switch>{children}</Switch>
        </AppLayout>
    );
};
